// src/composables/useConfig.js

import { onMounted, ref } from 'vue';

const config = ref(null);
const defaultConfigPath = '/configs/config.default.json';
const validTypes = ['prohitrade', 'se', 'prohitrade-se'];
let initPromise = null;

const applyConfig = (data, type) => {
  config.value = data;
  if (type) {
    localStorage.setItem('selectedConfigType', type);
  }
  if (data.indexTitle) {
    document.title = data.indexTitle;
  }
};

const fetchConfig = async (type = 'default') => {
  const sanitizedType = (type && validTypes.includes(type)) ? type : 'default';
  const configFilePath = `/configs/config.${sanitizedType}.json`;

  try {
    const response = await fetch(configFilePath);
    const data = response.ok
      ? await response.json()
      : await (await fetch(defaultConfigPath)).json();

    applyConfig(data, sanitizedType);
    return data;
  } catch (_) {
    const defaultConfig = await (await fetch(defaultConfigPath)).json();
    applyConfig(defaultConfig, 'default');
    return defaultConfig;
  }
};

const initConfig = () => {
  if (initPromise) {
    return initPromise;
  }

  initPromise = (async () => {
    let canProceed = true;
    let backendType = null;
    try {
      // Ask list_checker client backend which UI flavor to use and also get version/env
      const res = await fetch('/ui/config', { credentials: 'same-origin' });
      if (res.ok) {
        const data = await res.json();
        if (data?.config_type) {
          backendType = data.config_type;
          localStorage.setItem('selectedConfigType', data.config_type);
        }
      } else {
        canProceed = false;
      }
    } catch (_) {
      canProceed = false;
    }

    if (!canProceed) {
      console.error('Cannot reach backend to determine UI config type. Blocking UI.');
      localStorage.setItem('UI_BLOCKED', '1');
      return;
    }

    const storedType = localStorage.getItem('selectedConfigType');
    const envType = process.env.VUE_APP_TYPE;
    const typeToLoad = storedType || backendType || envType;
    await fetchConfig(typeToLoad);
  })();

  return initPromise;
};

export const useConfig = () => {
  onMounted(() => {
    initConfig();
  });

  return { config, loadConfig: fetchConfig };
};
